import styled from "styled-components";

/**
 * 리스트 상단 "편집" 등에 쓰는 파란 액션 버튼 공용 코어.
 * 패딩/마진/디스플레이가 다른 화면은 styled(EditButton)`...`로 확장한다.
 */
export const EditButton = styled.button`
  border-radius: 5px;
  background: var(--admin-blue-default-blue, #0079e0);
  color: white;
  border: #0079e0;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
`;

export default EditButton;
